module.exports = __webpack_public_path__ + "img/table-active.7a5be810.svg";